
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetomumbaiinternatinationalairport() {



    const cardData =
    {
        keyword: 'Pune to Mumbai International Airport Cab ',
        heading: 'Morya Cabs:  Pune to Mumbai International Airport Cab ',
        headingDescription: 'Planning a trip from Pune to Mumbai International Airport? Whether you’re heading for a business trip, vacation, or catching a flight, Morya Cabs ensures a seamless and comfortable journey. Our professional drivers, well-maintained fleet, and affordable pricing make us the preferred choice for airport transfers. We understand the importance of reaching the airport on time, so we ensure timely pickups, smooth rides, and hassle-free arrivals. Book your Pune to Mumbai International Airport cab with Morya Cabs and travel stress-free to catch your flight.',

        top: 'Top Places to Visit Near Mumbai International Airport',

     "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Located just a short drive from Mumbai International Airport, the Gateway of India is one of Mumbai's most iconic landmarks. This grand monument overlooks the Arabian Sea and is a must-see for any traveler to Mumbai. It's a great spot for photography and exploring the historical significance of the city."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive is a famous promenade along the Arabian Sea that offers stunning views of the coastline, especially during sunset. It’s one of the most scenic spots in Mumbai and perfect for a peaceful walk or a relaxing evening by the sea."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach in Mumbai, Juhu Beach is known for its lively atmosphere, beachside snacks, and beautiful sunset views. It’s an ideal spot to relax before or after your flight. The beach is about a 30-minute drive from Mumbai International Airport."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
        "description": "If you're looking to explore Mumbai’s rich architectural heritage, the Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site that represents a fusion of Victorian Gothic and traditional Indian architecture. It’s one of the most beautiful railway stations in the world."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is dedicated to Lord Ganesha and is one of the most famous temples in Mumbai. It attracts thousands of devotees every day, and the temple’s peaceful and spiritual environment is perfect for a quick visit."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "This impressive cable-stayed bridge connects Bandra to Worli and offers stunning views of the city’s skyline and the Arabian Sea. It’s an engineering marvel and one of Mumbai’s most iconic structures, ideal for a photo opportunity."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Haji Ali Dargah is a beautiful mosque and dargah situated on an islet off the coast of Worli. The mosque is famous for its stunning architecture and serene location, making it a peaceful spot for reflection."
    },
    {
        "title": "Mumbai Zoo (Veermata Jijabai Udyan)",
        "description": "Located near Byculla, Mumbai Zoo is home to various animal species. If you have some extra time before your flight, it’s a great spot to see a wide range of wildlife and enjoy a leisurely walk."
    },
    {
        "title": "Colaba Causeway",
        "description": "If you're interested in shopping, Colaba Causeway is the place to be. This bustling street is lined with shops, cafes, and street vendors selling everything from clothes to accessories. It's a great spot to pick up souvenirs or explore local goods."
    },
    {
        "title": "Kala Ghoda Art Precinct",
        "description": "Kala Ghoda is a vibrant area known for its art galleries, boutiques, and cafes. It’s a perfect place to soak in the artistic and cultural vibe of Mumbai before heading to the airport. Many art exhibitions and cultural events are held here throughout the year."
    }
],



"services": [
    {
      "name": "Pune to Mumbai International Airport Cab",
      "description": "For a seamless travel experience, Morya Cab offers reliable Pune to Mumbai International Airport Cab services. Our fleet of comfortable and well-maintained vehicles ensures that you reach Mumbai's international airport on time and in style. Whether you're traveling for business or leisure, we guarantee a stress-free journey."
    },
    {
      "name": "Pune to Mumbai Airport",
      "description": "Booking a Pune to Mumbai Airport taxi with Morya Cab provides a hassle-free and smooth ride. Our experienced drivers ensure timely arrivals and departures, so you can focus on your travel plans without worrying about the journey."
    },
    {
      "name": "Mumbai International Airport to Pune Cab",
      "description": "Morya Cab also provides comfortable and affordable rides from Mumbai International Airport to Pune Cab. Our service ensures a relaxed and convenient ride to your desired destination in Pune. With our professional drivers, your journey will be both safe and comfortable."
    },
    {
      "name": "Mumbai International Airport to Pune Cab Service",
      "description": "When you choose our Mumbai International Airport to Pune Cab Service, you are opting for reliability and comfort. We offer a wide range of vehicles, from sedans to larger SUVs, to meet your travel needs. Our drivers are familiar with the best routes to make your trip as quick and comfortable as possible."
    },
    {
      "name": "Pune to Chhatrapati Shivaji International Airport Cab",
      "description": "If you are heading to Chhatrapati Shivaji International Airport from Pune, Morya Cab offers the most reliable and convenient taxi service. Book your Pune to Chhatrapati Shivaji International Airport Cab with us to enjoy a smooth ride, where we take care of the details, so you can focus on your journey ahead."
    },
    {
      "name": "Pune to Mumbai Domestic Airport Cab",
      "description": "For those flying domestically, Morya Cab provides excellent service for Pune to Mumbai Domestic Airport Cab rides. Our drivers ensure that you arrive on time and enjoy a comfortable, safe ride throughout the trip."
    },
    {
      "name": "Taxi from Mumbai International Airport to Pune",
      "description": "Choose Morya Cab for a Taxi from Mumbai International Airport to Pune. Whether you’re arriving late at night or during the day, our airport pickup service guarantees you a timely and comfortable ride home."
    },
    {
      "name": "Pune to Chhatrapati Shivaji International Airport Taxi",
      "description": "Morya Cab offers Pune to Chhatrapati Shivaji International Airport Taxi services that are both affordable and reliable. With professional drivers and well-maintained cars, we aim to make your airport transfer as smooth as possible."
    },
    {
      "name": "Pune to Mumbai International Airport Innova Taxi",
      "description": "If you prefer extra space and comfort, book a Pune to Mumbai International Airport Innova Taxi. Ideal for families or groups, the Innova provides the perfect combination of comfort and style for your airport ride."
    },
    {
      "name": "Pune to Mumbai Drop Taxi",
      "description": "For a one-way ride, Morya Cab offers Pune to Mumbai Drop Taxi services. Whether you're traveling for business or leisure, we ensure you reach Mumbai in comfort and on time, with no additional stress."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Morya Cab is renowned for providing the Best Cab Service Pune to Mumbai. Our fleet of vehicles and professional drivers are committed to offering you the most comfortable, reliable, and efficient taxi service for your journey to Mumbai."
    },
    {
      "name": "Best Cab Service from Pune to Mumbai Airport",
      "description": "If you are looking for the Best Cab Service from Pune to Mumbai Airport, Morya Cab is the right choice. Our on-time service and well-maintained cars ensure a hassle-free journey to catch your flight."
    },
    {
      "name": "Pune to Mumbai Airport Cab Charges",
      "description": "Morya Cab offers competitive and transparent Pune to Mumbai Airport Cab Charges. We provide clear pricing with no hidden fees, so you can plan your trip without worrying about the cost."
    },
    {
      "name": "Pune to Mumbai Airport Cab Booking",
      "description": "Booking your Pune to Mumbai Airport Cab with Morya Cab is simple and convenient. You can easily book online or call us for an instant reservation, ensuring a smooth start to your travel."
    },
    {
      "name": "Book Your Pune to Mumbai Airport Cabs",
      "description": "Book your Pune to Mumbai Airport Cabs today with Morya Cab for a safe, timely, and comfortable ride to the airport. Our dedicated customer service and professional drivers will make sure you have a stress-free journey."
    },
    {
      "name": "Pune to Mumbai Airport Contact Information",
      "description": "For more details on Pune to Mumbai Airport Cab services or to make a booking, contact Morya Cab at +91 9371304510. We look forward to providing you with a smooth and hassle-free ride to Mumbai's airport!"
    }
  ],



  tableData: [
    ["Pune to Mumbai International Airport Cab", "-Pune to Mumbai Airport"],
    ["Mumbai International Airport to Pune Cab", "-mumbai international airport to pune cab service"],
    ["Pune to Chhatrapati Shivaji International Airport Cab", "-Pune to mumbai domestic airport cab"],
    ["Taxi from Mumbai International Airport to Pune", "-Pune to Chhatrapati Shivaji International Airport Taxi"],
    ["Pune to Mumbai International Airport Innova Taxi", "-Pune to Mumbai Drop Taxi"],
    ["Best Cab Service Pune to Mumbai", "-Best cab service from Pune to Mumbai Airport"],
    ["Pune to Mumbai Airport cab charges", "-Pune to mumbai airport cab booking"],
    ["Book your Pune to Mumbai Airport Cabs", "-"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab understands the importance of catching your flight on time. We ensure timely pickups from Pune, so you can reach Mumbai International Airport with ample time for check-in and security procedures, giving you a stress-free start to your journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a range of vehicles including sedans, SUVs, and premium cars that are designed for comfort and convenience. With spacious interiors, air conditioning, and comfortable seating, your ride from Pune to Mumbai Airport will be relaxing and pleasant."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced in handling airport transfers and are well-versed with the best routes to Mumbai International Airport. They are professional, courteous, and ensure a smooth, safe journey, giving you peace of mind throughout your trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for airport transfers. We provide transparent pricing with no hidden charges, so you’ll know exactly what to expect in terms of fare. We aim to provide excellent service at affordable rates."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with the latest safety features such as airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable ride to the airport."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab operates 24/7, meaning we’re always available to accommodate your airport transfer needs, no matter the time of day or night. Our customer service team is available round the clock to assist with your bookings."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Mumbai International Airport cab is quick and easy! You can book your ride through our website, mobile app, or by contacting our customer service team, who will help you with any questions or special requests."
    },
    {
        "WhyChooseheading": "Customized Travel Options",
        "WhyChoosedescription": "Whether you have a late-night flight or an early morning departure, we offer flexible pickup timings and customized travel options to suit your needs. Let us know your preferences, and we’ll make sure to accommodate them for a smooth ride."
    }
]


        
















    }

    const faqData = [
        {
          question: "How can I book a Pune to Mumbai International Airport cab with Morya Cab?",
          answer: "You can book your ride easily through our website, mobile app, or by contacting our customer service team who will assist you in the booking process."
        },
        {
          question: "Are the drivers experienced for airport transfers?",
          answer: "Yes, all our drivers are experienced in handling airport transfers and know the best routes to ensure you reach Mumbai International Airport on time."
        },
        {
          question: "What types of vehicles are available for Pune to Mumbai Airport travel?",
          answer: "We offer a variety of vehicles, including sedans, SUVs, and premium cars, all designed to provide comfort during your airport transfer."
        },
        {
          question: "How do I pay for my Pune to Mumbai International Airport cab rental?",
          answer: "We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, for your convenience and security."
        },
        {
          question: "Can I book a round trip to Mumbai International Airport?",
          answer: "Yes, we offer round trip services for airport transfers. Simply let us know your return details, and we’ll ensure your transfer back to Pune is as smooth as your arrival."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges for waiting time or detours will be clearly communicated upfront, ensuring full transparency in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing before my flight?",
          answer: "Yes, we offer sightseeing services for those with some free time before their flight. You can explore nearby spots on your way to the airport."
        },
        {
          question: "What is the luggage allowance for a Pune to Mumbai International Airport taxi?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific needs, please inform us during the booking process, and we’ll make necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate airport transfers between Pune and Mumbai?",
          answer: "Yes, we offer corporate travel services for business-related airport transfers, ensuring your employees or clients enjoy a comfortable and professional ride."
        },
        {
          question: "Why should I choose Morya Cab for my Pune to Mumbai International Airport transfer?",
          answer: "Morya Cab provides reliable, safe, and comfortable airport transfers with experienced drivers, affordable pricing, and excellent customer service, making it the ideal choice for your airport transfer needs."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Sameer Kumar',
          role: 'Traveler',
          review: "I used Morya Cab for my early morning flight from Pune to Mumbai International Airport. The driver was on time, the vehicle was clean and comfortable, and I reached the airport with plenty of time to spare. Highly recommend!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Anita Verma',
          role: 'Business Traveler',
          review: "Booked a cab with Morya Cab for my business trip to Mumbai. The driver was professional and courteous, and I had a smooth ride to the airport. Excellent service, I’ll definitely use Morya Cab again for future airport transfers!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "Pune to Mumbai International Airport Cab",
        "description": "Book a comfortable and affordable taxi from Pune to Mumbai International Airport (Chhatrapati Shivaji International Airport) with Morya Cabs. We offer reliable, safe, and convenient taxi services for your airport journey.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/pune-to-mumbai-international-airport-cab",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/pune-to-mumbai-airport-cab.jpg",
          "https://moryacab.com/img/mumbai-airport-taxi.jpg"
        ],
        "priceRange": "₹2500 - ₹4000",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/pune-to-mumbai-international-airport-cab",
          "priceCurrency": "INR",
          "price": 3000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.8,
          "reviewCount": 210
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anita Patel"
            },
            "datePublished": "2024-12-05",
            "reviewBody": "I had a seamless experience booking a cab from Pune to Mumbai International Airport. The driver was punctual, and the ride was very comfortable. Highly recommended for anyone traveling to the airport from Pune."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi Kumar"
            },
            "datePublished": "2024-11-22",
            "reviewBody": "Great service! The taxi was on time, and the driver was polite. The car was clean and spacious. The journey was smooth and quick. Will definitely book again for my next trip to Mumbai Airport."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Mumbai International Airport Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 18.5204,
            "longitude": 73.8567
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/pune-to-mumbai-international-airport-cab"
        },
        "keywords": "Pune to Mumbai International Airport Cab, Pune to Mumbai Airport, Mumbai International Airport to Pune Cab, Mumbai International Airport to Pune Cab Service, Pune to Chhatrapati Shivaji International Airport Cab, Pune to Mumbai Domestic Airport Cab, Taxi from Mumbai International Airport to Pune, Pune to Chhatrapati Shivaji International Airport Taxi, Pune to Mumbai International Airport Innova Taxi, Pune to Mumbai Drop Taxi, Best Cab Service Pune to Mumbai, Best Cab Service from Pune to Mumbai Airport, Pune to Mumbai Airport Cab Charges, Pune to Mumbai Airport Cab Booking, Book Your Pune to Mumbai Airport Cabs"
      };
      


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Pune to Mumbai International Airport Cab | Affordable & Reliable Taxi Service | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Book a comfortable and affordable taxi from Pune to Mumbai International Airport (Chhatrapati Shivaji International Airport) with Morya Cabs. We offer reliable, safe, and convenient taxi services for your airport journey."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai International Airport Cab, Pune to Mumbai Airport, Mumbai International Airport to Pune Cab, Mumbai International Airport to Pune Cab Service, Pune to Chhatrapati Shivaji International Airport Cab, Pune to Mumbai Domestic Airport Cab, Taxi from Mumbai International Airport to Pune, Pune to Chhatrapati Shivaji International Airport Taxi, Pune to Mumbai International Airport Innova Taxi, Pune to Mumbai Drop Taxi, Best Cab Service Pune to Mumbai, Best Cab Service from Pune to Mumbai Airport, Pune to Mumbai Airport Cab Charges, Pune to Mumbai Airport Cab Booking, Book Your Pune to Mumbai Airport Cabs"
  />
  <meta property="og:title" content="Pune to Mumbai International Airport Cab | Morya Cabs" />
  <meta
    property="og:description"
    content="Book a reliable taxi from Pune to Mumbai International Airport. Enjoy a comfortable ride at affordable rates. Available for one-way and round trips. Book now!"
  />
  <meta property="og:url" content="https://moryacab.com/pune-to-mumbai-international-airport-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://moryacab.com/img/pune-to-mumbai-airport-cab.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetomumbaiinternatinationalairport;